import { Component, Input, OnInit } from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { CaseService } from '../../services/case.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-delegate',
  templateUrl: './delegate.component.html',
  styleUrls: ['./delegate.component.scss']
})
export class DelegateComponent implements OnInit {

 
  delegateArr:any=[];
  statusId;

  getUrl:any;
  eCaseId:any;
  DelegateDescription=''; 
  fileLoad: any;
  FileName: any;
  roleId:any;
    sendWithoutFactsAndReasons = true;
    addsuggestedDecision = true;
  caseData:any;
  attachmentList:any=[];
  OffenderList:any=[];
  assignTo=0;
  superVisorArr:any=[];
  fetchData=false;
  
  @Input() loadDataFP: Observable<any>;
  caseId: any;
  object: any;

    constructor(public sharedService: SharedHttpService, public router: ActivatedRoute, public toastr: NotificationService, public route: Router, public caseService : CaseService) { }


    ngOnInit(): void {
        this.delegateArr = [];
        this.loadDataFP.subscribe((data) => {
          setTimeout(() => {
    this.loadData();
          }, 100);
    
      });
    }



    loadData() {
      this.fetchData=false;
      this.sendWithoutFactsAndReasons=true;
      this.object = this.caseService.getCaseData();
      this.eCaseId=this.object.eCaseId;
      this.caseId = this.object.caseId;
      this.roleId = JSON.parse(localStorage.getItem('user'))['roleId'];
      this.caseData = this.caseService.getCaseData();
      this.delegateArr = [];
      this.getUrl = `api/Delegate/GetAllowedStatuses?eCaseId=${this.eCaseId}`

      this.sharedService.get(`api/Attachment/GetAttachmentsList?ElementId=${this.caseId}&ElementTypeId=11`).subscribe(res => {
          this.attachmentList = res;
          this.caseService.setAttachmentList(this.attachmentList);

          this.sharedService.get(`api/CaseMember/GetCaseMembers?ecaseId=${this.eCaseId}`).subscribe(res => {
            this.OffenderList = res;


            this.sharedService.get(this.getUrl).subscribe(res=>{
              this.delegateArr=res;
              this.statusId =  this.delegateArr.statusId;
              this.fetchData==true;
              
            });

          });

      });


    }


    checktype(name) {
      var ext = name.split('.').pop();
  
      if (ext == "doc"
        || ext == "docx"
        || ext == "xls"
        || ext == "xlsx"
        || ext == "ppt"
        || ext == "pptx"
        || ext == "png"
        || ext == "jpg"
        || ext == "jpeg"
        || ext == "tiff"
        || ext == "pdf"
        || ext == "svg"
        || ext == "bmp"
        || ext == "ico"
  
      )
        return true;
      else
        return false;
    }
  
  
UploadFile(file: any){
  this.fileLoad=file;
  this.FileName=file.target.files[0].name;
  console.log(file.target.files[0].name);
  if (!this.checktype(file.target.files[0].name)) {
    return;
  }
}

clear(){
  this.fileLoad=undefined;
  this.FileName=null;
}
statusSelected(statusId){
    this.statusId = statusId;


    console.log(statusId);
    console.log("this.caseData",this.caseData);
    if (this.roleId == 4 && this.statusId == 8) {
        this.addsuggestedDecision = (this.caseData.suggestedDecision != null && this.caseData.suggestedDecision != "");
        console.log("addsuggestedDecision",this.addsuggestedDecision);
    if((!(this.caseData.caseFcts.length==0)) || (!(this.caseData.caseReasons.length==0))){
        this.sendWithoutFactsAndReasons = false;
    }else{
      this.sendWithoutFactsAndReasons=true;

    }
  };
  if(statusId==16){
   // console.log('moshreeeeeef');
    this.sharedService.get('api/Delegate/GetSupervisor').subscribe(res=>{
       
        if (this.caseData.assignedUserRoleId != null) {
            this.assignTo = this.caseData.assignedUserRoleId;
        }

 this.superVisorArr = res;

    });

  


  }
    if (statusId == 2) {
       // console.log('Manager');
        this.sharedService.get('api/Delegate/GetManager').subscribe(res => {
           

  if (this.caseData.assignedMngrUserRoleId != null) {
            this.assignTo = this.caseData.assignedMngrUserRoleId  ;
            }

            this.superVisorArr = res;
        });


      

    }

    if (statusId == 3) {
       // console.log('Employee');
        this.sharedService.get('api/Delegate/GetEmployee').subscribe(res => {
           

            if (this.caseData.assignedEmpUserRoleId != null) {
                this.assignTo = this.caseData.assignedEmpUserRoleId  ;
            }
              this.superVisorArr = res;

           // console.log("ass", res);
        });
     
    }



  else {
    this.assignTo=0;
    this.superVisorArr=[];
  }
}
  onSubmit() {
      let url = 'api/Delegate/InsertDelegation';
      let formData: FormData = new FormData();
    
      formData.append('statusId', this.statusId);
      formData.append('description',this.DelegateDescription);
      formData.append('eCaseId', this.eCaseId);
      formData.append('assignTo', this.assignTo.toString());

      if(this.fileLoad != undefined){
        formData.append('FileName', this.fileLoad.target.files[0].name);
        formData.append('ContentType', this.fileLoad.target.files[0].type);
          formData.append('file', this.fileLoad.target.files[0]);
      }
      this.sharedService.post(url, formData).subscribe(
        (response) => {        
          this.sharedService.showSuccessKey("DelegateSuccessfully");
          
          this.route.navigate([`/violation/case/case-done/${this.statusId}`]);
          
        },
          (error) => {                              
            console.error('error')
           this.sharedService.showSuccessKey("Notsaved");
          }
      );

    
    
  }

}

